import React from 'react';
import './TableFilterItem.css';

const TableFilterItem = (props) => (
    <div className={`table-filter-item ${props.className || ''}`}>
        {props.children}
    </div>
);

export default TableFilterItem;
